"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeContacts_de_de = void 0;
function backofficeContacts_de_de() {
    return {
        "backoffice.contacts.tab": "Kontakte",
        "backoffice.contacts.title": "Kontakte",
        "backoffice.contacts.subtitle": "Erstellen und verwalten Sie Ihre CRM Kontakte.",
        "backoffice.contacts.editor.edit": "Kontakt bearbeiten",
        "backoffice.contacts.editor.create": "Kontakt erstellen",
        "backoffice.contacts.editor.personal": "Persönliches",
        "backoffice.contacts.editor.reachability": "Erreichbarkeit",
        "backoffice.contacts.editor.company": "Firma",
        "backoffice.contacts.editor.customfields": "Benutzerdefinierte Felder",
        "backoffice.contacts.editor.notes": "Notizen",
        "backoffice.contacts.detail.title": "Kontaktdetails",
        "backoffice.contacts.customfield.tab": "Kontaktfelder",
        "backoffice.contacts.customfield.title": "Benutzerdefinierte Kontaktfelder",
        "backoffice.contacts.customfield.subtitle": "Erstellen Sie eigens definierte Kontaktfelder, welche an allen Kontakten gepflegt werden können.",
        "backoffice.contacts.customfield.titleprop": "Kontaktfeldtitel",
        "backoffice.contacts.customfield.titledescription": "Der Titel, welcher das Kontaktfeld beschreibt.",
        "backoffice.contacts.customfield.name": "Kontaktfeldschlüssel",
        "backoffice.contacts.customfield.namedescription": "Einzigartiger Schlüssel, bestehend aus einem Wort, welcher das Kontaktfeld identifizieren kann (z.B. istVegetarierin)",
        "backoffice.contacts.customfield.type": "Kontaktfeldtyp",
        "backoffice.contacts.customfield.typedescription": "Datentyp des Kontaktfeldes",
        "backoffice.contacts.customfield.editexplaination": "Kontaktfeldschlüssel und -typ können nicht angepasst werden.",
        "backoffice.contacts.customfield.create": "Kontaktfeld erstellen",
        "backoffice.contacts.customfield.edit": "Kontaktfeld bearbeiten",
        "backoffice.contacts.customfield.deletion.title": "ACHTUNG: Kontaktfeld löschen",
        "backoffice.contacts.customfield.deletion.message": "ACHTUNG: Das Löschen eines Kontaktfeldes wird dieses Kontaktfeld von allen Ihren Kontakten entfernen. Sind Sie sicher, dass Sie alle Kontkatfelder dieses Typen entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden!",
        "backoffice.contacts.publicaccess.label": "Öffentlicher Kontakt",
        "backoffice.contacts.publicaccess.description": "Dieser Kontakt kann ohne Authentifizierung gelesen werden. Dies ist beispielsweise erforderlich, wenn der Kontakt in einer öffentlichen Check-In App auswählbar sein soll."
    };
}
exports.backofficeContacts_de_de = backofficeContacts_de_de;
